import React, { Component } from 'react';
import MalidCard from './MalidCard';


class IslexView extends Component {
	render() {
		const langPath = ['EN', 'POL'].includes(this.props.lang) ? '' : `/tungumal/${this.props.lang}`;
		return (
			<MalidCard title={this.props.frontPage ? this.props.subTitle : this.props.title || window.l('islex_title')}
				subTitle={this.props.frontPage ? null : this.props.subTitle === this.props.title ? null : this.props.subTitle}
				count={this.props.count}
				visible={(this.props.data && this.props.data.length > 0)} forceHidden={(this.props.hideOnFrontPage && this.props.frontPage)}
				frontPage={this.props.frontPage}
				aboutText={this.props.aboutText || window.l('islex_about')}
				includeFlags={true}
				database={'islex_'+this.props.lang}>
				{
					this.props.data && this.props.data.map(function(item, index) {
						return <div className="card-text" key={index}>
							{
								index > 0 && <hr className="divider"/>
							}
							{
								!this.props.hideUrl && (
									<React.Fragment>
									<a target="_blank" href={`${this.props.url || 'http://islex.arnastofnun.is'}/is/ord/${item.id}${langPath}`}>
										{item.fletta}
									</a> {item.ordflokkur}
									</React.Fragment>
								)
								}
							{
								this.props.hideUrl &&
								<React.Fragment><strong>{item.fletta}</strong> {item.ordflokkur}</React.Fragment>
							}

							{
								item.lidir && item.lidir.length > 0 && <React.Fragment>
									<br/><br/>
									{
										item.lidir.map((lidur, lIndex) => {
											return <div className="lidir" key={lIndex}>
												<strong>{lidur.num}</strong> {
													lidur.target_lang !== '' &&
													<React.Fragment>
														{lidur.target_lang}{lidur.zmerking ? ' '+lidur.zmerking : ''}<br/>
													</React.Fragment>
												}
												{
													lidur.tl_skyring &&
													<React.Fragment>
														{lidur.tl_skyring}<br/>
													</React.Fragment>
												}
											</div>
										})
									}
								</React.Fragment>
							}
							{
								item.merking && item.merking.length > 0 && item.merking[0].target_lang !== '' && <div className="merking">
									<hr/>
									{
										item.merking.map((merking, mIndex) => {
											return <React.Fragment key={mIndex}>
												{merking.target_lang}<br/><br/>
												{
													merking.daemalisti && merking.daemalisti.length > 0 && merking.daemalisti.map((daemi, dIndex) => {
														return <React.Fragment key={dIndex}>
															<div className={'daemi-thyding'}>
																<em><strong>{daemi.daemi}</strong></em><br/>
																<p className={'thyding'}>{daemi.thyding}</p>
															</div>
														</React.Fragment>
													})
												}

											</React.Fragment>
										})
									}
								</div>
							}
							{
								item.ordasambandalisti && item.ordasambandalisti.length > 0 && <div className="ordasambond">
									<hr/>
									{
										item.ordasambandalisti.map((ordasamband, osIndex) => {
											return <React.Fragment key={osIndex}>
												<div className={'daemi-thyding'}>
												<em><strong>{ordasamband.ordasamband}</strong></em><br/>
												<p className={'thyding'}>
													{ordasamband.thyding.split("''").join("'")}<br/>

												</p>

												</div>
											</React.Fragment>
										})
									}
								</div>
							}


							{
								// Eldri útgáfa
							}
							{
								item.skyring && item.skyring.map(function(skyring, skIndex) {
									return <React.Fragment key={skIndex}>
										{skyring.texti}<br/>
									</React.Fragment>
								})
							}
							{
								item.daemi && item.daemi.map(function(daemi, dIndex) {
									return <React.Fragment key={dIndex}>
										<strong><em>{daemi.texti}</em></strong><br/>
									</React.Fragment>
								})
							}
							{
								item.sostaeda && item.sostaeda.map(function(sostaeda, dIndex) {
									return <React.Fragment key={dIndex}>
										{sostaeda.texti}<br/>
										{
											sostaeda.skyring && sostaeda.skyring.map(function(skyring, skIndex) {
												return <div className="ml-4">{skyring.texti}</div>
											})
										}
									</React.Fragment>
								})
							}
							{
								item.ostaeda && item.ostaeda.map(function(ostaeda, dIndex) {
									return <React.Fragment key={dIndex}>
										{ostaeda.texti}<br/>
										{
											ostaeda.skyring && ostaeda.skyring.map(function(skyring, skIndex) {
												return <div className="ml-4">{skyring.texti}</div>
											})
										}
									</React.Fragment>
								})
							}
							{
								!this.props.hideUrl &&
								<React.Fragment>
									<br/>
									<a target="_blank"
									   className="text-light"
									   href={`${this.props.url || 'http://islex.arnastofnun.is'}/is/ord/${item.id}${langPath}`}>
									   {item.merking_fjoldi === 1
									   ? 'Fara í orðabók'
									   : `Sjá ${item.merking_fjoldi} merkingar í orðabók`}
									</a>
								</React.Fragment>
							}
						</div>
					}.bind(this))
				}
			</MalidCard>
		);
	}
}

export default IslexView;



// WEBPACK FOOTER //
// ./src/components/IslexView.js